import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgStar = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M3.068 14.873q.224.169.504.113.282-.05.613-.283l3.811-2.75 3.82 2.75q.33.234.612.283.28.057.504-.113a.65.65 0 0 0 .267-.438q.05-.276-.087-.658L11.606 9.38l3.848-2.714q.339-.234.468-.48a.65.65 0 0 0-.295-.89q-.252-.129-.67-.122l-4.72.029L8.803.785q-.13-.39-.331-.587A.64.64 0 0 0 7.996 0a.66.66 0 0 0-.475.198q-.195.198-.324.587L5.763 5.203l-4.72-.029q-.417-.006-.67.12a.65.65 0 0 0-.295.891q.129.247.468.48L4.394 9.38l-1.506 4.397q-.137.382-.094.658.05.275.274.438"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;
